export {default} from './Clearfix';



// WEBPACK FOOTER //
// ./src/components/Clearfix/index.ts